import React from "react";
import "./BirdStats.scss";
import utils from "../../../../../helpers/utils";
import { BirdConfig } from "../../WildLifeTourismConfig";
import LargeStat from "../../../../Stats/LargeStat";
import SmallStat from "../../../../Stats/SmallStat";

function BirdStats(props) {
  const { stats, selectedGeometry } = props;

  /**
   * Full stats are full width
   */
  const fullStats = BirdConfig.stats;

  /**
   * short stats are half width
   */
  const shortStats = [];

  const country = utils.getCountryAttrForSelectedGeometry(
    selectedGeometry
  );

  return (
    <div className="birdStats">
      {Object.keys(stats).length > 0 && (
       <>
       {fullStats.map((item) => (
         <LargeStat
           key={item.name}
           item={item}
           stats={stats}
           country={country}
         />
       ))}
       <div className="shortStatArea">
         {shortStats.map((item) => (
           <SmallStat
             key={item.name}
             item={item}
             stats={stats}
             country={country}
           />
         ))}
       </div>
     </>
      )}
    </div>
  );
}

export default BirdStats;
